import { useId } from 'react';

// Full-color TruX triad brand mark (Safety / Privacy / Freedom pillars). Flat tri-color fills (no
// gradients), so it stands on a transparent background rather than inside a solid brand tile. The
// mask ID is namespaced via useId so multiple instances never collide.
export function LogoTriad({ size = 30, title }: { size?: number; title?: string }) {
  const raw = useId().replace(/:/g, '');
  const id = (name: string) => `${name}-${raw}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1000 1000"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title && <title>{title}</title>}
      <defs>
        <mask id={id('triad')}>
          <path d="M500 167 L860 790 L140 790 Z" fill="#ffffff" stroke="#ffffff" strokeWidth="120" strokeLinejoin="round" />
          <line x1="500" y1="582" x2="500" y2="910" stroke="#000000" strokeWidth="54" />
          <line x1="500" y1="582" x2="236" y2="430" stroke="#000000" strokeWidth="54" />
          <line x1="500" y1="582" x2="764" y2="430" stroke="#000000" strokeWidth="54" />
          <circle cx="500" cy="582" r="120" fill="#000000" />
          <path d="M554 300 L464 300 L446 318 L446 342 L464 360 L536 360 L554 378 L554 402 L536 420 L446 420" fill="none" stroke="#000000" strokeWidth="26" />
          <path d="M315 640 L315 760" fill="none" stroke="#000000" strokeWidth="26" />
          <path d="M315 653 L372 653 L390 671 L390 690 L372 707 L315 707" fill="none" stroke="#000000" strokeWidth="26" />
          <path d="M685 640 L685 760" fill="none" stroke="#000000" strokeWidth="26" />
          <path d="M685 653 L760 653" fill="none" stroke="#000000" strokeWidth="26" />
          <path d="M685 705 L745 705" fill="none" stroke="#000000" strokeWidth="26" />
        </mask>
      </defs>
      <g mask={`url(#${id('triad')})`}>
        <path d="M500 582 L0 294 L0 0 L1000 0 L1000 294 Z" fill="#FF3D52" />
        <path d="M500 582 L0 294 L0 1000 L500 1000 Z" fill="#8A4FE0" />
        <path d="M500 582 L500 1000 L1000 1000 L1000 294 Z" fill="#FFA52E" />
      </g>
      <circle cx="500" cy="582" r="78" fill="#FF3D52" />
    </svg>
  );
}
